<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-body">
            <h5 class="card-title text-center">SkillLink Privacy Policy</h5>
            <p><strong>Last Updated:</strong> August 1, 2024</p>
            <p>
              SkillLink is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and disclose your personal information when you use our website or applications.
            </p>
            <h6><strong>Information We Collect</strong></h6>
            <p>
              We collect information you provide directly to us, such as your name, email address, and any other information you choose to provide. We also collect information about your use of our Site, including your IP address, browser type, and operating system.
            </p>
            <h6><strong>How We Use Your Information</strong></h6>
            <p>
              We use your information to provide and improve our services, communicate with you, and personalize your experience. We may also use your information for marketing purposes with your consent.
            </p>
            <h6><strong>Sharing Your Information</strong></h6>
            <p>
              We do not sell or rent your personal information to third parties. We may share your information with third-party service providers who assist us in operating our Site or conducting our business, but only to the extent necessary for these purposes.
            </p>
            <h6><strong>Data Security</strong></h6>
            <p>
              We implement reasonable security measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is 100% secure.
            </p>
            <h6><strong>Your Choices</strong></h6>
            <p>
              You may update or correct your personal information by contacting us. You can also opt-out of receiving marketing communications from us by following the instructions in those communications.
            </p>
            <h6><strong>Changes to This Privacy Policy</strong></h6>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new Privacy Policy on our Site and updating the effective date.
            </p>
            <h6><strong>Contact Us</strong></h6>
            <p>
              If you have any questions about this Privacy Policy or our practices, please contact us at:
            </p>
            <p>
              <strong>SkillLink Privacy Team</strong><br />
              Email: <a href="mailto:mikethecoder12@gmail.com">mikethecoder12@gmail.com</a><br />
              Phone: <a href="tel:+254716002152">(+254) 71-600-2152</a><br />
              Address: Nairobi, Kenya
            </p>
            <p class="text-center">
              <router-link to="/terms-conditions" class="text-primary">Terms and Conditions</router-link> | <router-link to="/privacy-policy" class="text-primary">Privacy Policy</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
a {
  text-decoration: none;
  color: rgb(107, 115, 133);
}

a:hover {
  text-decoration: underline;
  text-transform: initial;
}

.container {
  max-width: 800px;
}
</style>
